import { define, html } from "hybrids";
import {
  share,
  shareSocial,
  copy,
  supportsNative,
  ShareHost,
} from "~/utils/share";

export default define<ShareHost>({
  tag: "v-broadcast-share",
  url: "",
  name: "",
  copied: false,
  render: ({ name, url, copied }) => html`
    <div id="input">
      <v-ui-input>
        <input value="${url}" readonly />
      </v-ui-input>
      <v-ui-link onclick="${copy}">
        <v-ui-icon name="link" size="small" color="link"></v-ui-icon>
        ${copied ? "Copied" : "Copy link"}
      </v-ui-link>
    </div>
    ${supportsNative
      ? html`<v-ui-button-group>
          <v-ui-button name="Share" onclick="${share}"></v-ui-button>
        </v-ui-button-group>`
      : html`
          <div id="buttons">
            <v-ui-button
              onclick="${shareSocial("facebook")}"
              type="round"
              icon="facebook"
            ></v-ui-button>
            <v-ui-button
              onclick="${shareSocial("twitter")}"
              type="round"
              icon="twitter"
            ></v-ui-button>
            <v-ui-button
              href="mailto:?subject=${name}&body=${url}"
              type="round"
              icon="mail"
            ></v-ui-button>
            <v-ui-button
              onclick="${shareSocial("linkedin")}"
              type="round"
              icon="linkedin"
            ></v-ui-button>
            <v-ui-button
              onclick="${shareSocial("telegram")}"
              type="round"
              icon="telegram"
            ></v-ui-button>
            <v-ui-button
              onclick="${shareSocial("whatsapp")}"
              type="round"
              icon="whatsapp"
            ></v-ui-button>
          </div>
        `}
  `.css`
    :host {
      display: block;
    }

    #input {
      display: grid;
      grid: auto / 1fr auto;
      align-items: center;
      grid-gap: 16px;
      margin-bottom: 16px;
    }

    v-ui-link {
      color: var(--v-ui-color-link);
    }

    #buttons {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: 30px;
      grid-gap: 12px; 
      height: 30px;
    }
  `,
});
